import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { CONTACT } from "../config";
import { fireConversion, setEnhancedConversionData } from "../lib/tracking";
import { trackEvent } from "../lib/trackingClient";

// Conversion-Redirect-Routen: feuert Conversion (nach Consent) und leitet weiter.
export default function Redirect({ type: typeProp }) {
  const params = useParams();
  const type = typeProp || params.type;
  const navigate = useNavigate();

  useEffect(() => {
    const run = async () => {
      if (type === "whatsapp") {
        fireConversion("whatsapp");
        trackEvent("whatsapp_click", { value: 40 });
        window.location.href = `https://wa.me/${CONTACT.whatsapp}`;
      } else if (type === "anruf") {
        fireConversion("anruf");
        trackEvent("anruf_click", { value: 50 });
        window.location.href = `tel:${CONTACT.phoneHref}`;
      } else if (type === "chat") {
        navigate("/?chat=1", { replace: true });
      } else {
        navigate("/", { replace: true });
      }
    };
    run();
  }, [type, navigate]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-[#0E0F12] text-gray-400">
      <p>Einen Moment …</p>
    </div>
  );
}
